module.exports = __webpack_public_path__ + "8360069817cd7fd1f6fc4d592610e37d.woff2";